module.exports = __webpack_public_path__ + "img/covid2.a954cb2f.jpg";